import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalculatorAppDetailComponent } from './app-detail.component';
import { IconModule } from 'src/app/shared/components/icon/icon.module';

@NgModule({
  declarations: [
    CalculatorAppDetailComponent
  ],
  imports: [
    CommonModule,
    IconModule,
  ],
  exports: [
    CalculatorAppDetailComponent
  ]
})
export class CalculatorAppDetailModule { }
